var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('AccruedInterestCalculator',{staticClass:"mb-3"}),_c('AccruedInterestSchedule',{staticClass:"mb-3"}),_c('AmortizationSchedule',{staticClass:"mb-3"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }